export enum EStrings {
    EDITED_USER_ROLE="User role has been successfully changed",
    SNACKBAR_SUCCESS="success",
    SNACKBAR_ERROR="error",
    INPUT_FIELD_REQUIRED="Field is required."
}